export default __webpack_public_path__ + "static/media/logo.984fa17b.png";